var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJob({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "156.2875px",
    height: "163.8125px",
    viewBox: "0 0 156.2875 163.8125",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.5,163.8 C63.4974069,163.758678 36.7538222,137.015093 36.7125,104.0125 C36.7538221,71.0168104 63.4918104,44.2788221 96.4875,44.2375 C129.490102,44.2719215 156.239279,71.0099152 156.2875,104.0125 C156.246178,137.021997 129.496997,163.771178 96.4875,163.8125 L96.5,163.8 Z M96.5,56.7375 C70.400132,56.7650451 49.2469453,77.9126402 49.2125,104.0125 C49.233157,130.117249 70.3827654,151.278042 96.4875,151.3125 C122.599145,151.284942 143.759942,130.124145 143.7875,104.0125 C143.753042,77.9077654 122.592249,56.758157 96.4875,56.7375 L96.5,56.7375 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.2125,122.3 C110.842732,122.299228 109.511462,121.846685 108.425,121.0125 L93.1375,109.3375 C92.3789081,108.754754 91.763284,108.0066 91.3375,107.15 L76.9625,78.375 C75.5464995,75.3096728 76.8211874,71.6738857 79.8412917,70.1638335 C82.8613961,68.6537813 86.5348385,69.8155033 88.1375,72.7875 L101.875,100.25 L116.0125,111.0625 C118.134179,112.695689 118.982886,115.497044 118.124345,118.03313 C117.265803,120.569217 114.889953,122.278961 112.2125,122.2875 L112.2125,122.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.25,162.5 L6.25,162.5 C2.79822031,162.5 0,159.70178 0,156.25 L0,6.25 C0,2.79822031 2.79822031,0 6.25,0 L137.5,0 C140.95178,0 143.75,2.79822031 143.75,6.25 L143.75,25 C143.75,28.4517797 140.95178,31.25 137.5,31.25 C134.04822,31.25 131.25,28.4517797 131.25,25 L131.25,12.5 L12.5,12.5 L12.5,150 L31.25,150 C34.7017797,150 37.5,152.79822 37.5,156.25 C37.5,159.70178 34.7017797,162.5 31.25,162.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.75,37.5 L68.75,37.5 C65.2982203,37.5 62.5,34.7017797 62.5,31.25 C62.5,27.7982203 65.2982203,25 68.75,25 L118.75,25 C122.20178,25 125,27.7982203 125,31.25 C125,34.7017797 122.20178,37.5 118.75,37.5 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJob);
export default __webpack_public_path__ + "static/media/job.f2f7db3b41888dabe79cadfaee87b597.svg";
export { ForwardRef as ReactComponent };